module.exports = __webpack_public_path__ + "static/img/bannercontact.3df87e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/bannercontact.png
// module id = UaS7
// module chunks = 1